import {empty, urlRequest} from "../common/common";
import {api} from "../api/api";
import Vue from 'vue';

// vuex store 模块定义
export const vuexStore = {

  state: {
    // 是否登录状态
    isLogin: !empty(localStorage.getItem('token')),
    // 用户信息
    // userInfo: JSON.parse((localStorage.getItem('userInfo') && "undefined"!=="undefined") ?localStorage.getItem('userInfo') : null),
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
    // 订单列表数据
    orderList: {all: []},
  },

  getters: {
    // 获取不同类型订单列表数据，如全部订单，已入住订单
    typeOrderList: state => typeName => {
      return state.orderList[typeName];
    }
  },

  mutations: {

    // 修改登录状态
    setLoginStatus(state, loginStatus) {
      state.isLogin = loginStatus;
    },

    // 保存用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },

    // 保存订单列表数据
    saveOrderList(state, orderList) {
      state.orderList = {...orderList};
    },

    // 删除订单列表数据
    delOrderList(state) {
      state.orderList = {all: []};
    },
  },

  actions: {

    // 获取订单列表信息
    getOrderList({commit, state}) {
      console.log('vuex action getOrderList begin: ')
      if (state.isLogin) {
        urlRequest({
          url: api.getOrderList,
          method: 'get',
        }).then(res => {
          let orderList = res.data.data;
          // 将查询到的数据按id倒序排列，让最新的订单出现在最前面
           // 创建一个新对象来存储分类后的订单
        let categorizedOrders = { all: [] };
        
        // 首先将所有订单按id倒序排列
        orderList.sort((a, b) => b.id - a.id);
        
        // 将排序后的全部订单存入all数组
        categorizedOrders.all = [...orderList];
          commit('saveOrderList', categorizedOrders);
        });
      }
    },

  }

};
